<template>
  <div id="roaming-countries">
    <div v-if="!show && !error" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: calc(100vh - ( 280px + 170px));">
      <Loader />
    </div>
    <Error v-if="error" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: calc(100vh - ( 280px + 170px));"/>
    <div  class="social-nav filter-blur-50 border-bottom-white-1-50" v-if="show">
      <div class="nameContainer" style="width: 50vw">
        <router-link to="/personal" class="d-flex">
          <div class="homeIcon">
            <a><img src="../../assets/icons/homeIcon.svg" height="20px" width="20px"></a>
          </div>
        </router-link>
        <div class="arrowIcon">
          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
        </div>
        <router-link to="/roaming" class="d-flex">
          <div class="bundleTitle">
            {{RoamingTitle}}
          </div>
        </router-link>
        <div class="arrowIcon">
          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
        </div>
        <div class="titleName">{{roamingCountries}}</div>
      </div>
      <div :class="[this.$lang === 'ar' ? 'flex-start-center' : '', 'checkContainer']" >
        <form :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'filterForm']">
          <div class="checkName" :class="this.$lang === 'ar' ? 'right-dir' : ''">{{$t('popularBundles.showResults')}}</div>
          <div class="check">
            <input type="radio" id="pre" name="filter" value="0" checked @change="filter(0)">
            <label for="pre" class="radioLabel pre">{{$t('popularBundles.PrePaid')}}</label>
          </div>
          <div class="check">
            <input type="radio" id="post" name="filter" value="1" @change="filter(1)">
            <label for="post" class="radioLabel post">{{$t('popularBundles.PostPaid')}}</label>
          </div>
        </form>
      </div>
    </div>
    <div class="mapContainer" v-if="show">
      <router-link to="/roaming" class="d-flex">
        <div class="returnBack">
          <a><img src="../../assets/icons/ReturnBack.svg" style="width: 40px;" class="backButton"></a>
        </div>
      </router-link>
      <div class="mainTitle">
        {{SMSRoamingCountries}}
      </div>
      <div class="description">
        {{description}}
      </div>
      <div class="selectContainer">
        <div class="mainSelect" @click="arabic">
          <Dropdown
            v-model="selectedCity"
            :options="cities"
            optionLabel="name"
            :filter="true"
            class="test"
            :placeholder="selectPlaceholder"
            @change="getId" />
        </div>
      </div>
    </div>
    <div class="content" v-if="show">
      <!--        <div v-if="!show" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: 30rem">-->
      <!--          <Loader />-->
      <!--        </div>-->
      <div class="insideContent" v-if="show">
        <div class="contentTitle" :class="[ this.$lang === 'ar' ? 'arabicTitle' : '']">
          <span style="padding: 0 5px"> {{$t('roamingCountries.secTitle')}} </span> <span v-if="selectedCity != null" class="selectedName">{{selectedCity.name}}</span>
        </div>
        <div class="description2">{{$t('roamingCountries.description2')}}</div>
        <div v-if="cardsLoader" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: 30rem">
          <Loader />
        </div>
        <div class="cardsContainer">
          <div  v-for="(card,i) in cards" :key="i">
            <!--              <div> {{card.title}}</div>-->
            <!--              <div v-if="selectedCity != null">{{selectedCity.content}}</div>-->
            <roaming-card :open="String(card.id)" :name="card.name" :list="card.providerService"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from 'primevue/dropdown'
import RoamingCard from '../../components/cards/RoamingCard'
import RoamingCitiesRepository from '../../repositories/RoamingCitiesRepository'
import RoamingCardsRepository from '../../repositories/RoamingCardsRepository'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
import $ from 'jquery'
export default {
  name: 'index',
  components: { RoamingCard, Dropdown, Loader, Error },
  data () {
    return {
      lang: this.$lang,
      roamingCities: new RoamingCitiesRepository(),
      roamingCards: new RoamingCardsRepository(),
      RoamingTitle: this.$t('roamingCountries.roamingInternational'),
      roamingCountries: this.$t('roamingCountries.roamingCo'),
      SMSRoamingCountries: this.$t('roamingCountries.roamingCo'),
      description: this.$t('roamingCountries.description1'),
      selectedCity: null,
      selectPlaceholder: 'Search & Select country name',
      id: null,
      cardName: '',
      show: false,
      error: false,
      // cities: [
      //   { name: 'New York', code: 'NY', content: [{ title: 'ali' }] },
      //   { name: 'Rome', code: 'RM', content: [{ title: 'ali' }, { title: 'ali' }] },
      //   { name: 'London', code: 'LDN', content: [{ title: 'ali' }, { title: 'ali' }, { title: 'ali' }] },
      //   { name: 'Istanbul', code: 'IST', content: [{ title: 'ali' }] },
      //   { name: 'Paris', code: 'PRS', content: [{ title: 'ali' },{ title: 'ali' },{ title: 'ali' },{ title: 'ali' }] }
      // ],
      cities: [],
      cards: [],
      list: [],
      cardsLoader: false,
      filterType: 0
      // cards: [
      //   {
      //     title: 'vodafon',
      //     id: 'ali'
      //   },
      //   {
      //     title: 'MTN',
      //     id: 'saleh'
      //   },
      //   {
      //     title: 'Syriatel',
      //     id: 'ddd'
      //   }
      // ]
    }
  },
  mounted () {
    this.getCities()
    this.arabic()
    this.arabicRadio()
    // this.getCards()
  },
  methods: {
    async getCities () {
      try {
        const response = await this.roamingCities.get()
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            this.cities.push(response.data[i])
            // this.selectedCity = this.cities[140]
            if (this.cities[i].code === 'LB') {
              this.selectedCity = this.cities[i]
              this.id = this.cities[i].id
              // console.log('id is', this.selectedCity.name)
            }
          }
          // this.id = this.cities[140].id
          // console.log('ko', this.cities)
          this.cards = []
          this.getCards()
          this.fetched = true
          this.show = true
        } else {
          this.error = true
          this.show = false
        }
      } catch (e) {
        this.error = true
        this.show = false
        console.log(e)
      }
    },
    async getCards () {
      this.cards = []
      this.cardsLoader = true
      const line = this.filterType
      try {
        const response = await this.roamingCards.getFilterById(`${this.id}/web/international`, line)
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            this.cards.push(response.data[i])
            for (let j = 0; j < this.cards[i].providerService.length; j++) {
              this.cards[i].providerService[j].isOpened = false
            }
          }
          this.cardsLoader = false
          this.fetched = true
          this.show = true
        } else {
          this.cardsLoader = true
          this.error = true
          this.show = false
        }
      } catch (e) {
        this.cardsLoader = true
        this.error = true
        this.show = false
        console.log(e)
      }
    },
    getId () {
      this.cards = []
      this.id = this.selectedCity.id
      this.getCards()
    },
    arabic () {
      if (this.lang === 'ar') {
        // console.log('language is', this.lang)
        // $('.insideContent').css('direction', 'rtl')
        $('.mainTitle, .contentTitle').css('font-family', 'Mtn-arabic-bold')
        $('.p-dropdown').css('font-family', 'Mtn-arabic-regular')
        $('.returnBack').addClass('arabicBack')
        $('.p-dropdown-filter-icon').css('right', '0')
        $('.p-dropdown-filter-icon').css('left', 'unset ')
        $('.checkContainer').css('direction', 'ltr')
      } else {
        $('.p-dropdown-filter-icon').css('right', 'unset')
        $('.p-dropdown-filter-icon').css('left', '0')
      }
    },
    arabicRadio () {
      if (this.$lang === 'ar') {
        $('.post').css('font-family', 'Mtn-arabic-regular')
        $('.pre').css('font-family', 'Mtn-arabic-regular')
        $('.post').css('font-size', '10px')
        $('.pre').css('font-size', '10px')
        if ($('#pre').is(':checked')) {
          $('.pre').css('font-family', 'Mtn-arabic-bold')
          $('.pre').css('font-size', '10px')
          // $('.post').css('font-family', 'Mtn-arabic-regular')
          // $('.post').css('font-size', '11px')
        } else if ($('#post').is(':checked')) {
          $('.post').css('font-family', 'Mtn-arabic-bold')
          $('.post').css('font-size', '10px')
          // $('.pre').css('font-family', 'Mtn-arabic-regular')
          // $('.pre').css('font-size', '11px')
        }
      }
    },
    filter (val) {
      this.filterType = val
      this.getCards()
      this.arabicRadio()
    }
  }
}
</script>

<style scoped lang="scss">
  @import "src/assets/sass/main";
  @import "~primevue/resources/primevue.min.css";
  @import "~primeicons/primeicons.css";
  #roaming-countries{
    padding-top: 160px;
  }
  .arabicTitle{
    direction: rtl;
  }
  #roaming-countries .social-nav{
    //background: rgba(212, 212, 212, 0.45);
    //background-color: $--light-white;
    height: 50px;
    //box-shadow: 10px 10px 30px 0px rgba(0, 0, 0, 0.1) !important;
    background: rgba(242, 242, 242, 1);
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
    //backdrop-filter: blur(40px);
    margin: 0px 0px;
    display: flex;
    position: fixed;
    z-index: 10;
    z-index: 210;
    top: 110px;
  }
  .arabicBack{
    right: 4vw;
    left: unset !important;
    transform: rotateY(180deg);
  }
  .arabicSearch{
    right: 0 !important;
    left: unset !important;
  }
  #roaming-countries .nameContainer{
    display: flex;
    padding: 0 4vw 0 3.2vw;
  }
  #roaming-countries .homeIcon {
    cursor: pointer;
  }
  .homeIcon,
  .arrowIcon,
  .titleName{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  #roaming-countries .titleName{
    width: max-content;
    color: $--yellow;
    font-family: Mtn-bold;
    text-decoration: underline;
  }
  #roaming-countries .bundleTitle{
    width: max-content;
    font-family: Mtn-regular;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  .backArrow{
    width: 35px;
    height: 35px;
    margin-bottom: 50px;
  }
  .descriptionDir{
    direction: rtl!important;
  }
  .rotateArrow{
    transform: rotateY(180deg);
  }
  .mapContainer{
    height: 300px;
    width: 100%;
    background-color: #ffffff6b;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    background-image: url("../../assets/images/roamingMap.png");
    background-size: 90% 90%;
    background-position: center;
    position: relative;
  }
  .returnBack{
    position: absolute;
    left: 4vw;
    top: 50px;
  }
  @media screen and (max-width: 430px) {
    .returnBack{
      position: absolute;
      left: 6vw;
      top: 35px;
    }
    .backButton{
      width: 30px !important
    }
  }
  @media screen and (max-width: 430px) {
    #roaming-countries .titleName {
      text-align: start;
      padding: 0 3.5vw;
    }
  }
  .mainTitle{
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 23px;
    font-style: italic;
    font-family: Mtn-bold-italic;
    color: #FFCB05;
    padding-top: 50px;
  }
  .description{
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    padding-top: 50px;
    font-family: Mtn-medium;
  }
  .description2{
    padding: 0 5vw;
  }
  @media screen and (max-width: 480px) {
    .mainTitle{
      font-size: 17px;
    }
    .description{
      font-size: 12px;
    }
    /*.mainSelect{*/
    /*  min-width: 250px !important;*/
    /*}*/
  }
  .selectContainer{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mainSelect{
    width: 30%;
    min-width: 260px;
    padding: 15px 0px;
  }
  .content{
    /*min-height: 35rem;*/
    min-height: calc(100vh - ( 280px + 170px));
    background-color: rgba(242, 242, 242, 1);
    border-top: 2px white solid;
    border-radius: 43px 43px 0 0;
    margin-top: -37px;
    /* z-index: 10; */
    position: relative;
  }
  .insideContent{
    /*min-height: 35rem;*/
    min-height: calc(100vh - ( 280px + 170px));
    width: 100%;
    height: 100%;
    background-image: url("../../assets/images/line-page-circles.svg");
    background-position: right;
    background-position-y: top;
    //background-size: 25% 90%;
  }
  .contentTitle{
    color: #FFCB05;
    font-size: 18px;
    font-family: Mtn-bold;
    padding: 50px 0 10px 0;
  }
  .selectedName{
    color: black;
    font-size: 18px;
    font-family: Mtn-bold-italic;
    font-style: italic;
  }
  .cardsContainer{
    padding: 4vh 1vw;
  }
  .checkContainer{
    display: flex;
    justify-content: flex-end;
    width: 50vw;
    padding: 0 3vw;
    font-family: Mtn-regular;
  }
  .check{
    padding: 0 2vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .checkName{
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Mtn-bold;
    font-style: italic;
  }
  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label
  {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #1D1D1D;
  }
  [type="radio"]:checked + label:before,
  [type="radio"]:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 2.5px solid $--yellow;
    border-radius: 100%;
    background: transparent;
  }
  [type="radio"]:checked + label:after,
  [type="radio"]:not(:checked) + label:after {
    content: '';
    width: 8px;
    height: 8px;
    background: $--yellow;
    position: absolute;
    top: 5px;
    left: 5px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  [type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  [type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
    font-weight: bold;
  }
  input[type="radio"]:checked+label {
    font-family: Mtn-bold;
    /*font-family: Mtn-arabic-bold;*/
  }
  @media screen and (max-width: 650px) {
    .checkName {
      display: none;
    }
  }
  @media screen and (max-width: 950px) {
    .homeIcon,
    .arrowIcon,
    #roaming-countries .bundleTitle,
    .checkName{
      display: none;
    }
    .nameContainer{
      width: 40vw !important;
    }
    .checkContainer{
      width: 60vw !important;
    }
  }
  @media screen and (max-width: 390px) {
    .nameContainer, .check{
     font-size: 12px
    }
  }
  @media screen and (max-width: 800px) {
    .mapContainer{
      background-size: 131% 83%;
    }
  }
    .filterForm{
    display: flex;
  }
</style>
<style lang="scss">
#roaming-countries {
  .p-dropdown {
    width: 100%;
    border: 2px #FFCB05 solid;
    border-radius: 15px;
    height: 50px;
    display: flex;
    /* justify-content: start; */
    align-items: center;
    text-align: start;
    padding: 0 2vw 0 2vw;
  }
  .p-dropdown .p-dropdown-panel {
    min-width: 100%;
    background: white;
    min-height: 7rem;
    border-radius: 15px;
    text-align: center;
  }
  .p-dropdown-items{
    padding-left: 0!important;
  }
  .p-dropdown-item{
    height: 45px;
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .p-dropdown-filter:focus{
    outline: none!important;
  }
  .p-dropdown-filter-container {
    height: 40px;
    border-bottom: 2px #FFCB05 solid;
    margin: 5px 2vw;
  }
  .p-dropdown-filter {
    width: 100%;
    height: 100%;
    padding: 0 25px;
  }
  .p-dropdown-filter-icon{
    color: #FFCB05;
  }
  .p-dropdown-trigger {
    color: #FFCB05;
  }
}
</style>
